// extracted by mini-css-extract-plugin
module.exports = {"unsubscribePage":"style_unsubscribePage__2zJKE","successMessage":"style_successMessage__21BJr","title":"style_title__1Q3WS","link":"style_link__2EWVH"};